<template>
  <el-dialog title="Thông báo" :visible.sync="localVisible" width="560px" :append-to-body="false">
    <div style="word-break: keep-all;">
      Bạn vừa hoàn thành thanh tra lớp {{ detail?.class_name }} - buổi {{ detail?.lesson_id }} - Câu {{ detail?.sentence }} của giảng viên {{ detail?.teacher_name }}.
      <br />
      <div>Bạn có muốn tiếp tục thực hiện chấm lại bài tập này không?</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <button class="btn btn-light-gray font-weight-bold mr-2" @click="$emit('later')">
        <i class="fas fa-times"></i> Chấm sau
      </button>
      <button class="btn btn-purple font-weight-bold mr-2" @click="$emit('now')">
        <i class="fas fa-arrow-right"></i> Tiếp tục
      </button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'NeedMarkHomeworkAgainDialog',
  props: {
    visible: { type: Boolean, default: false },
    detail: { type: Object, default: null },
  },
  computed: {
    localVisible: {
      get() { return this.visible; },
      set(v) { this.$emit('update:visible', v); }
    }
  }
}
</script>

<style scoped>
</style>


